import { encryptData } from './GpgService';
import config from '../config/env';

const API_URL =
  config.apiUrl ||
  (document.referrer ? new URL(document.referrer).origin + '/wp-json/hipaa-forms/v1' : '');
const REDIRECT_URL = config.thankYouPageUrl;
const GTM_DATA = { GA: undefined, FBPixel: undefined };

/**
 * Validates if the origin is allowed for postMessage
 */
function isOriginAllowed(origin) {
  // In development, allow any origin
  if (process.env.NODE_ENV === 'development') {
    return true;
  }
  return config.allowedOrigins.includes(origin);
}

export function setGTMData(data) {
  GTM_DATA.clientId = data.clientId;
  GTM_DATA.uTMSource = data.uTMSource;
  GTM_DATA.fbc = data.fbc;
  GTM_DATA.fbp = data.fbp;
}

export function formatData(data, formSettings) {
  return Object.keys(data).map((k) => {
    const field = formSettings.fields.find((f) => f.key === k);
    return {
      key: k,
      name: field?.name,
      value: field?.type === 'date' ? data[k].toLocaleDateString('en-US') : data[k] || undefined,
      label: field?.options?.find((o) => o.value === +data[k])?.label,
      isHidden: false
    };
  });
}

export async function sendHipaaForm(type, data, token) {
  const { fbc, fbp, clientId, uTMSource } = GTM_DATA;
  const gtmData = [
    { key: 'GA', value: JSON.stringify({ clientId, uTMSource }), name: 'GA', isHidden: true },
    { key: 'FBPixel', value: JSON.stringify({ fbp, fbc }), name: 'FBPixel', isHidden: true }
  ];

  let encryptedData;
  try {
    encryptedData = await encryptData({ fields: [...data, ...gtmData] });
  } catch (error) {
    throw new Error('Failed to encrypt form data');
  }

  let response;
  try {
    response = await fetch(`${API_URL}/${type}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: encryptedData, token })
    });
  } catch (error) {
    throw new Error('Network error: Unable to submit form. Please check your connection.');
  }

  if (response.status !== 200) {
    const errorText = await response.text().catch(() => 'Unknown error');
    throw new Error(`Server error: ${errorText || 'Unable to process your request'}`);
  }

  if (REDIRECT_URL && document.referrer) {
    const referrerOrigin = new URL(document.referrer).origin;

    if (!isOriginAllowed(referrerOrigin)) {
      console.warn('Unauthorized origin for postMessage:', referrerOrigin);
      // Don't throw error, just return success without redirect
      return await response.json();
    }

    window.parent?.postMessage(
      { type: 'hipaa-form:submitted', redirectUrl: REDIRECT_URL },
      referrerOrigin
    );

    return await response.json();
  } else {
    return await response.json();
  }
}
